module.exports = __webpack_public_path__ + "img/smile.0304ec52.png";